var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"align":"center","justify":"center"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }